import React, { lazy } from 'react';
import { CheckIcon } from 'lucide-react';
export function TransformationSection() {
  const benefits = [{
    title: 'PASO 1:',
    description: 'Crear tu producto desde 0'
  }, {
    title: 'PASO 2:',
    description: 'Configurar tu tienda de shopify y dejarla lista para vender'
  }, {
    title: 'PASO 3:',
    description: 'Diseñar tu pagina de ventas + Ads'
  }, {
    title: 'PASO 4:',
    description: 'Lanzar tus campañas de ventas'
  }];
  return <section className="py-8 md:py-12 px-4 bg-[#2F0240] pt-[40px] pb-[40px] mt-[-20px] mb-[-20px] space-y-[16px]" data-id="element-375" data-mp="2j5h38u3x29ti">
      <div className="max-w-5xl mx-auto pt-[10px] pb-[10px] mt-[-15px] mb-[-15px]" data-id="element-376" data-mp="2e7fkkaaekcik">
        <div className="rounded-2xl p-8 md:p-12 mb-8 bg-[#FFFFFF] animate-neon-violet" data-id="element-377" data-mp="299dzxkxbw54z">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-378" data-mp="247x3c1lvn4u7">
            EN UN FIN DE SEMANA APRENDERÁS A👇
          </p>

          <div className="space-y-4" data-id="element-379" data-mp="209r196vzhdfm">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 rounded-lg p-4 shadow-sm bg-[#FAC7F3B1]" data-id="element-380" data-mp="f8zkpxtfgrxb" data-mpi={index}>
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-381" data-mp="5dxvz332drv9" />
                <span className="text-lg text-gray-700" data-id="element-382" data-mp="abg6uz0n6h5w">
                  <span className="font-black uppercase text-[#353135]" data-id="element-383" data-mp="a9wrrbqq2c5p">
                    {benefit.title}
                  </span>{' '}
                  {benefit.description}
                </span>
              </div>)}
          </div>
        </div>

        {/* Video Section */}
        <div className="flex justify-center mb-8" data-id="element-384" data-mp="p2yikkmgxpjg">
          <div className="aspect-[221/476] w-[280px] max-w-full sm:w-[320px]" data-id="element-385" data-mp="t1pjz3xyvtcd">
            <iframe src="https://www.facebook.com/plugins/video.php?height=689&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F995316486471237%2F&show_text=false&width=320&t=0" width="320" height="689" style={{
            border: 'none',
            overflow: 'hidden'
          }} scrolling="no" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" className="h-full w-full rounded-xl shadow-[0_0_20px_rgba(252,157,255,0.3)]" data-id="element-386" data-mp="39rcrar697rhv"></iframe>
          </div>
        </div>

        {/* Beneficios Header */}
        <div className="mb-8 text-center bg-gradient-to-r from-[#9C16A3] to-[#6B0F70] rounded-2xl p-8 border-2 border-purple-400/50" data-id="element-387" data-mp="11herd9h7o6rm">
          <h3 className="md:text-4xl font-black text-white uppercase mb-2 text-[25px]" data-id="element-388" data-mp="rks64jkz3dp2">
            ¿Qué vas a lograr?
          </h3>
          <div className="space-y-4 text-left max-w-xl mx-auto mt-4" data-id="element-389" data-mp="mniin9h59c3v">
            <div className="flex items-start gap-3" data-id="element-390" data-mp="2lzupdzjfhzjj">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-391" data-mp="2lx8kk7nx9y50">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-392" data-mp="2ph8q237ociks">
                Generar ingresos REALES desde casa (sin experiencia)
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-393" data-mp="2tgr90tfxqjkz">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-394" data-mp="2y9aqi1hqtyv2">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-395" data-mp="337c8ej3fns4y">
                Tener claridad absoluta y un paso a paso accionable
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-396" data-mp="2aj81xvd1fb17">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-397" data-mp="2alt28fxotiwu">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-398" data-mp="2khw4rmwgbjkb">
                Ahorrar tiempo y dinero con un método que realmente FUNCIONA
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-399" data-mp="3vxcegl9o7b9e">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-400" data-mp="3vw1dsubiujmi">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-401" data-mp="18p57aqkcoxgr">
                Lograr ventas todos los días y tener tu billetera con estos ingresos mensuales👇🏻
              </p>
            </div>
            <div className="mt-6 flex justify-center" data-id="element-402" data-mp="1hngyatp4px9q">
              <img src="https://cdn.magicpatterns.com/uploads/6MKusnCKfxnvQ2YSmY8jGU/image.png" alt="Facturación mensual de US$ 16,846.51" loading="lazy" className="w-full max-w-md rounded-xl shadow-lg" data-id="element-403" data-mp="1cpfaxwko7bsg" />
            </div>
          </div>
        </div>

        <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-12 text-center pt-[20px] pb-[20px] mt-[-20px] mb-[-20px]" data-id="element-404" data-mp="20f9mmat96ub4">
          <p className="text-xl md:text-2xl mb-4 font-[400]" data-id="element-405" data-mp="2ae8p1bnfdtpo">
            No prometemos magia. No es "apretar un botón"
          </p>
          <p className="md:text-3xl font-black text-[#FC9DFF] text-[26px]" data-id="element-406" data-mp="25g75kpm37sdo">
            Prometemos una metodología probada que SÍ funciona✅
          </p>

          <div className="mt-8 max-w-2xl mx-auto" data-id="element-407" data-mp="2oz3dqs04dv5p">
            <div className="grid grid-cols-2 gap-3 md:gap-5" data-id="element-408" data-mp="2tyzcoctymwee">
              <img src="https://cdn.magicpatterns.com/uploads/uRxsqcPoU8ZQZhioHMEJMj/WhatsApp_Image_2026-07-16_at_00.27.39.jpg" alt="Resultados de facturación de una tienda online" loading="lazy" className="w-full h-auto rounded-xl border-2 border-[#FC9DFF]/70 shadow-lg" data-id="element-409" data-mp="2f309nglpjmg4" />
              <img src="https://cdn.magicpatterns.com/uploads/sFiY1kwfjZz6FmrsJACLGV/WhatsApp_Image_2026-07-16_at_00.27.39_(1).jpg" alt="Ingresos diarios de una nueva oferta online" loading="lazy" className="w-full h-auto rounded-xl border-2 border-[#FC9DFF]/70 shadow-lg" data-id="element-410" data-mp="2b2psr8wdnbmh" />
            </div>
            <p className="mt-6 text-lg md:text-2xl font-bold leading-relaxed text-white" data-id="element-411" data-mp="1rdffe1k3t2rj">
              Si a ti también te gustaría lanzar tu oferta este fin de semana y
              comenzar a generar ingresos como estos…{' '}
              <span className="text-[#FC9DFF]" data-id="element-412" data-mp="3p7jff2hhln7k">sigue deslizando👇</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}